"use strict";

exports.__esModule = true;
exports.default = void 0;
var _tagTester = _interopRequireDefault(require("./_tagTester.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _tagTester.default)('RegExp');